.zeroState {
    padding: var(--spacer-56) var(--spacer-40);
    border-bottom: 1px solid var(--gray-300);
    text-align: center;
}

.zeroStateHeading {
    color: var(--gray-700);
    font: var(--font-h-24-forma);
}

.subcategoryHeading {
    padding-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-h-32);
    text-align: center;
}

.favoritesState {
    container-type: inline-size;
}

.gridHeader {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: var(--spacer-24);

    @media print {
        display: none;
    }
}

.productCount {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.headerActions {
    display: flex;
    gap: var(--spacer-24);
    align-items: center;
}

.headerActionButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.headerActionSvg {
    width: 24px;
    height: 24px;
}

.productList {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";
    display: grid;
    gap: var(--labui-grid-gap);
    grid-template-columns: 1fr 1fr;
    container-type: inline-size;

    @container (min-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr;
    }

    @media print {
        gap: var(--spacer-12);
    }

    > * {
        grid-column: span 1;

        @container (max-width: 500px) {
            grid-column: span 2;
        }

        @media print {
            &:has([class*="GridPromoCard"]) {
                display: none;
            }
        }
    }
}

.errorState {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    text-align: center;
    font: var(--font-p-18);
}

.footerContent {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    margin-top: var(--spacer-64);
    padding-top: var(--spacer-56);
    border-top: 1px solid var(--gray-300);

    @media print {
        display: none;
    }
}

.empty {
    padding-block: var(--spacer-80);
}
